import { Component, OnInit } from '@angular/core';

import { UserblockService } from './userblock.service';
import { AuthService } from '../../../shared/services/authentication.service';

@Component({
    selector: 'app-userblock',
    template: require('./userblock.component.html'),
    styles: [require('./userblock.component.scss')]
})
export class UserblockComponent implements OnInit {
    user: any;
    constructor(private userblockService: UserblockService, private authService: AuthService) {

        this.user = {
            name: this.authService.getUserName()
        };
    }

    ngOnInit() {
    }

    userBlockIsVisible() {
        return this.userblockService.getVisibility();
    }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/layout/sidebar/userblock/userblock.component.ts